import {PopupSimple} from '..'

export const PolarCollectPop = (props: any) => {
  return (
    <div
      css={{
        background: '#00000040',
        width: '100vw',
        height: '100vh',
        position: 'fixed',
        top: 0,
        left: 0,
        zIndex: '101',
      }}>
      <PopupSimple
        {...props}
        method=''
        name='Data Collection Task for Polar H10 auto-generated'
        description='Polar devices require users to manually turn logging on and off. Thus, there needs to be an associated task. We’ve auto-generated a default task, feel free to make any edits.'
        buttonText='I got it'
      />
    </div>
  )
}
